module.exports = __webpack_public_path__ + "img/logo.9b42e61a.svg";